// extracted by mini-css-extract-plugin
export default {"root":"ErrorLine_root__RBrE5"};